import { render, staticRenderFns } from "./ActivityPost.vue?vue&type=template&id=a65aa32a&scoped=true&"
import script from "./ActivityPost.vue?vue&type=script&lang=js&"
export * from "./ActivityPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65aa32a",
  null
  
)

export default component.exports